import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "@/lib/i18n";

// Lightweight page-level SEO wrapper. Emits title, meta description,
// canonical, Open Graph and Twitter card. Optional JSON-LD for structured data.
export default function Seo({ title, description, path = "/", image, jsonLd }) {
  const { lang } = useLang();
  const base = "https://loftpress.shop";
  const url = `${base}${path}`;
  const img = image || `${base}/logo512.png`;
  const fullTitle = title ? `${title} · LoftPress` : "LoftPress — First-party API Platform";
  const desc = description || "First-party developer APIs from LoftPress: currency FX, holidays, VAT, email, IBAN and QR — through one secure gateway.";
  return (
    <Helmet>
      <html lang="en" data-lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="LoftPress" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
